import react, { useEffect, useState } from 'react'
import { Divider } from 'antd'
import styles from './styles.module.css'
import noData from '../../../assets/img/Emptyjobs.png'

const EducationHistory = ({ data }) => {
    const [currentEducation, setCurrentEducation] = useState('');
    useEffect(() => {
        let filteredData = data.filter((item) => !item.Deleted);
        setCurrentEducation(filteredData);
        
    }, [data]);

    return (
        <>
            <div
                className={styles['education-history-main']}
                style={{
                    padding: '3% 4%',
                    borderRadius: '4px',
                    border: 'solid 1px #e4e4e4',
                    background: '#fff',
                    height: 'max-content'
                }}
            >
                

                {currentEducation?.length > 0 ?
                    currentEducation?.map((res, index) => {
                        {
                            // if(!res.Deleted){

                                return (
                                    <>
                                    <div key={index} className={styles['edu-history-container']}>
                                        <div>
                                            {res?.Courses?.CourseName ?? res?.CourseTypes?.CourseTypeName} - {res?.CourseTypes?.CourseTypeName}
                                        </div>
                                        <span>{res?.Schools?.SchoolName}</span> <br />
                                        <span>Graduated {res.YearCompleted}</span>
                                    </div>
    
                                    {currentEducation.length > 0 && currentEducation.length - 1 !== index ? <Divider /> : null}
                                </>
                            )

                            // }
                        }  
                        

                    }) :
                    <>
                        <div style={{
                            width: '50%',
                            margin: 'auto',
                        }}>
                            <img src={noData} style={{ width: '100%' }} />
                        </div>
                        <div style={{ textAlign: 'center' }}>No Education history !</div>
                    </>
                }
            </div>
        </>
    )
}
export default EducationHistory